// extracted by mini-css-extract-plugin
export default {"header":"AppRouter__header--1I4","content":"AppRouter__content--3Tm"};